import React, { useContext } from 'react';
import { Button, Icon } from 'anf-core-react';
import { useLocation } from 'react-use';
import buildQueryString from '../../../../tools/buildQueryString';
import tmntHelpers from '../../../../tools/tmntHelpers';
import analyticsTriggers from '../../../../analytics/analyticsTriggers';
import useHasGoldenStateAnalytics from '../../../../helpers/hasGoldenStateAnalytics';
import ProductPageContext from '../../../../contexts/ProductPageContext';

export default function ShareButton({
  brandName, seq, tmntData, parentBrand, productName,
}) {
  const location = useLocation();
  const productPageState = useContext(ProductPageContext);
  const hasGoldenStateAnalytics = useHasGoldenStateAnalytics();

  const shareProduct = () => {
    const cmp = parentBrand === 'anf' ? 'WEB:EVG23:AK:AK:All:Brand:X:X:X:X:X:X:ALLSITE:x:PDPShare' : 'WEB:EVG23:HCo:D:All:Brand:X:X:X:X:X:X:ALLSITE-HCo:x:PDPShare';
    navigator.share({
      title: productName,
      text: tmntHelpers.replacePlaceholders(tmntData.shareMessage?.value, { 0: brandName }),
      url: `${location.origin}${location.pathname}?${buildQueryString({ seq, cmp })}`,
    });
    analyticsTriggers.universalClick('share', 'pdp share', hasGoldenStateAnalytics, productPageState);
  };

  return (
    <Button
      isFullWidth
      variant="tertiary-light"
      onClick={shareProduct}
      classList="share-button"
    >
      <Icon icon="share" />
      {tmntData.shareLabel?.value}
    </Button>
  );
}
